export const environment = {
    production: false,
    apiUrl: 'https://api-dev.nonprod.cloud.univa.health/api/v1/',
    baseApiUrl: 'https://api-dev.nonprod.cloud.univa.health/api/',
    cometchatAppId: "276614253f239345",
    cometchatRegion: "eu",
    cometchatAuthKey: "d2d183b7e4f5dd0c9afe2d7302e9bda77d07c4bf"
};
